import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/manage/auctions/$auctionId")({
    component: Outlet,
    loader: async ({ context, params }) => {
        await context.queryClient.ensureQueryData(context.qof.auction.get(params.auctionId));
    },
});
